<app-ace-select
  bindLabel="benefit_name"
  bindValue="benefit_id"
  [appendTo]="appendTo"
  [formControl]="formControl"
  [hideSelected]="false"
  [isReadOnly]="isReadOnly"
  [items]="benefitOptions"
  [multiSelect]="multiSelect"
  [placeholder]="placeholder | messageTranslate"
  [closeOnSelect]="!multiSelect"
  [clearable]="clearable ?? !showNoneOption"
  [maxSelectedLabels]="maxSelectedLabels"
  [maxSelectedShowItemName]="maxSelectedShowItemName"
  [maxSelectedItemName]="maxSelectedItemName"
  [truncateLabels]="truncateLabels"
  (touched)="onTouched()"/>
